module.exports = __webpack_public_path__ + "static/media/AIms-Logo.26cac684.jpg";